import React, { useEffect, useState } from "react";
import {Grid, Typography, TextField, MenuItem} from '@mui/material'
import PropTypes from 'prop-types'
import LoadingPopUp from "../../../components/Pop_ups/LoadingPopUp";
import ErrorPopUp from "../../../components/Pop_ups/ErrorPopUp";
import StatementOfWork from "./ContractsPages/StatementOfWork";
import TenNinetyNine from "./ContractsPages/10-99";
import MasterOfServicesUSA from "./ContractsPages/MasterOfServicesUSA";
import MasterOfServicesCanadian from "./ContractsPages/MasterServicesCanadian";


const fileTypes = ['docx', 'pdf']

/**
 * component used to create and send Offer Letters
 * @component 
 * @category Offer Letters
 */

function ContractForm(props) {

    const [loading, setLoading] = useState(false)
    const [deployContract, setDeployContract] = useState(null)
    const [error, setError] = useState(null)
    const [country, setCountry] = useState(null)

    const contracts = ["Master Services Agreement (C2C)", "Supplemental Statement of Work", "1099"]
    const countries = ["Canada", "United States"]

    useEffect(() => {
    }, [props.optionalFields])

    return (
        <Grid sx={{ flexDirect: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', padding: '2%', height: '100%' }}>
            {error ? 
            <ErrorPopUp errorTitle = "Something has gone wrong" errorContent={error} />
            :
            <></>
            }
           
            <LoadingPopUp open={loading} />
            <Typography align='center' variant='h4'>Manage Contracts</Typography>
            <Grid  xs={3}>
                <TextField required label="Contract Type" onChange={(e) => { e.preventDefault(); setDeployContract(e.target.value) }}
                    value={deployContract} fullWidth select>
                    {contracts.map((contract) => (
                        <MenuItem key={contract} value={contract}>
                            {contract}
                        </MenuItem>
                    ))}
                </TextField>
                { deployContract === "Master Services Agreement (C2C)" ?
                <TextField required label="Country" onChange={(e) => { e.preventDefault(); setCountry(e.target.value) }}
                    value={country} fullWidth select>
                    {countries.map((country) => (
                        <MenuItem key={country} value={country}>
                            {country}
                        </MenuItem>
                    ))}
                </TextField>
                : <></>
                }
            </Grid>
            {deployContract === "Master Services Agreement (C2C)" && country === "United States" ? 
            <MasterOfServicesUSA setError = {setError} {...props} setLoading = {setLoading} fileTypes= {fileTypes} ></MasterOfServicesUSA> :
            <></>
            }
            {deployContract === "Master Services Agreement (C2C)" && country === "Canada" ? 
            <MasterOfServicesCanadian setError = {setError} {...props} setLoading = {setLoading} fileTypes= {fileTypes} ></MasterOfServicesCanadian> :
            <></>
            }
            {deployContract === "Supplemental Statement of Work" ?
                <StatementOfWork setError = {setError} {...props} setLoading = {setLoading} fileTypes= {fileTypes}/> :
                <></>
            }
            {deployContract === "1099" ?
                <TenNinetyNine setError = {setError} {...props} setLoading = {setLoading} fileTypes= {fileTypes}/> :
                <></>
            }
            
        </Grid>
    )
}

ContractForm.propTypes = {
    /**
     * list of valid signing authorities, following db schema
     */
    authorities: PropTypes.arrayOf(PropTypes.object).isRequired,
    /**
     * list of available clients, follwoing db schema
     */
    clients: PropTypes.arrayOf(PropTypes.object),
    /**
     * function to be called when sending out the offer letter is sucsessful
     */
    onComplete: PropTypes.func,
    /**
     * function to be called when an error occures
     */
    onError: PropTypes.func,
    /**
     * optional fields for the form
     */
    optionalFields: PropTypes.arrayOf(PropTypes.string)
}

ContractForm.defaultProps = {
    onError: () => { },
    optionalFields: ['period_interval', 'period_length']
}

export default ContractForm